export const zambiaProvinces = {
    Central: {
      districts: {
        Kabwe: ["Bwacha", "Kabwe Central"],
        KapiriMposhi: ["Kapiri Mposhi"],
        Chibombo: ["Katuba", "Keembe", "Chisamba"],
        Mkushi: ["Mkushi South", "Mkushi North"],
        Serenje: ["Muchinga", "Serenje"],
        Mumbwa: ["Mumbwa", "Nangoma"],
        Ngabwe: ["Ngabwe"],
        Chisamba: ["Chisamba"],
      },
    },
    Copperbelt: {
      districts: {
        Ndola: ["Chifubu", "Kabushi", "Ndola Central", "Bwana Mkubwa"],
        Kitwe: ["Nkana", "Wusakile", "Kamfinsa", "Kwacha", "Chimwemwe"],
        Luanshya: ["Roan", "Luanshya"],
        Chingola: ["Chingola", "Nchanga"],
        Mufulira: ["Mufulira", "Kantanshi"],
        Kalulushi: ["Kalulushi", "Lufwanyama"],
        Chililabombwe: ["Chililabombwe"],
        Masaiti: ["Masaiti"],
        Mpongwe: ["Mpongwe"],
        Lufwanyama: ["Lufwanyama"],
      },
    },
    Eastern: {
      districts: {
        Chipata: ["Chipangali", "Chipata Central", "Kasenengwa"],
        Katete: ["Katete"],
        Sinda: ["Sinda","Kapoche"],
        Petauke: ["Petauke Central", "Nyimba"],
        Lundazi: ["Lumezi", "Chasefu"],
        Mambwe: ["Mambwe"],
        Vubwi: ["Vubwi"],
      },
    },
    Luapula: {
      districts: {
        Mansa: ["Mansa Central", "Chembe"],
        Samfya: ["Bangweulu", "Mambilima"],
        Mwense: ["Mwense"],
        Kawambwa: ["Kawambwa"],
        Nchelenge: ["Chiengi"],
        Milenge: ["Milenge"],
        Chienge: ["Chienge"],
        Lunga: ["Lunga"],
        Chipili: ["Chipili"],
        Mwansabombwe: ["Mwansabombwe"],
        Chifunabuli: ["Chifunabuli"],
      },
    },
    Lusaka: {
      districts: {
        Lusaka: [
          "Matero",
          "Mandevu",
          "Munali",
          "Lusaka Central",
          "Kabwata",
          "Chawama",
          "Kanyama",
        ],
        Chilanga: ["Chilanga"],
        Kafue: ["Kafue"],
        Chongwe: ["Chongwe"],
        Rufunsa: ["Rufunsa"],
      },
    },
    Muchinga: {
      districts: {
        Chinsali: ["Chinsali", "Lubu"],
        Nakonde: ["Nakonde"],
        Isoka: ["Isoka"],
        Mpika: ["Mpika"],
        Mafinga: ["Mafinga"],
        Shiwangandu: ["Shiwangandu"],
        Kanchibiya: ["Kanchibiya"],
        lavshimanda: ["Mfuwe"],
      },
    },
    Northern: {
      districts: {
        Kasama: ["Kasama Central", "Lupososhi"],
        Mbala: ["Mbala"],
        Luwingu: ["Luwingu"],
        Kaputa: ["Kaputa"],
        Chilubi: ["Chilubi"],
        Mungwi: ["Mungwi"],
        Mpulungu: ["Mpulungu"],
        Nsama: ["Nsama"],
        Mporokoso: ["Mporokoso"],
      },
    },
    NorthWestern: {
      districts: {
        Solwezi: ["Solwezi Central", "Kalumbila"],
        Kasempa: ["Kasempa"],
        Mwinilunga: ["Mwinilunga"],
        Zambezi: ["Zambezi East", "Zambezi West"],
        Kabompo: ["Kabompo"],
        Manyinga: ["Manyinga"],
        Chavuma: ["Chavuma"],
        Ikelenge: ["Ikelenge"],
      },
    },
    Southern: {
      districts: {
        Livingstone: ["Livingstone"],
        Mazabuka: ["Mazabuka Central", "Magoye"],
        Monze: ["Monze Central", "Bweengwa", "Moomba"],
        Choma: ["Choma Central", "Pemba"],
        Kalomo: ["Kalomo Central"],
        Namwala: ["Namwala"],
        Gwembe: ["Gwembe"],
        Siavonga: ["Siavonga"],
        Sinazongwe: ["Sinazongwe"],
        Kazungula: ["Kazungula"],
        ItezhiTezhi: ["Itezhi Tezhi"],
        Council:["Council"]
      },
    },
    Western: {
      districts: {
        Mongu: ["Mongu Central", "Nalikwanda"],
        Sesheke: ["Sesheke"],
        Kalabo: ["Kalabo"],
        Kaoma: ["Kaoma", "Mangango"],
        Senanga: ["Senanga"],
        Shangombo: ["Shangombo"],
        Lukulu: ["Lukulu"],
        Nalolo: ["Nalolo"],
        Mwandi: ["Mwandi"],
        Sioma: ["Sioma"],
      },
    },
  };
  